import { render, staticRenderFns } from "./TelstraUIVueHeader.vue?vue&type=template&id=7f104e0c"
import script from "./TelstraUIVueHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./TelstraUIVueHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports